module.exports = __webpack_public_path__ + "img/icon_counter_minus.295f25b1.svg";